export default "__VITE_ASSET__DBVr5ZHV__"